/**
 * GENERATED CODE – DO NOT EDIT!
 */
/* eslint-disable */
import * as $protobuf from 'protobufjs/light';
import { fixType } from '../../../../../../../Fixes';
import Builder from '../../../../../../../Builder';
import '../common/vpos/checkout';
import '../common/signature';
import '../common/tipping';
import '../common/payment_sounds';
import '../common/security';
import '../rst/common/appearance';
import '../rst/common/text_customer';
import '../addons/loyalty';
import '../addons/text_message_marketing';
const $root = $protobuf.roots['default'] || ($protobuf.roots['default'] = new $protobuf.Root());
const jsonData = {
  "squareup": {
    "nested": {
      "devicesettings": {
        "nested": {
          "profiles": {
            "nested": {
              "v2": {
                "nested": {
                  "model": {
                    "nested": {
                      "settings": {
                        "nested": {
                          "squidkiosk": {
                            "nested": {
                              "SquidKioskSettings": {
                                "fields": {
                                  "checkout": {
                                    "type": ".squareup.devicesettings.profiles.v2.model.settings.common.vpos.Checkout",
                                    "id": 1,
                                    "rule": "optional"
                                  },
                                  "signature": {
                                    "type": ".squareup.devicesettings.profiles.v2.model.settings.common.Signature",
                                    "id": 2,
                                    "rule": "optional"
                                  },
                                  "tipping": {
                                    "type": ".squareup.devicesettings.profiles.v2.model.settings.common.Tipping",
                                    "id": 3,
                                    "rule": "optional"
                                  },
                                  "paymentSounds": {
                                    "type": ".squareup.devicesettings.profiles.v2.model.settings.common.PaymentSounds",
                                    "id": 4,
                                    "rule": "optional"
                                  },
                                  "security": {
                                    "type": ".squareup.devicesettings.profiles.v2.model.settings.common.Security",
                                    "id": 5,
                                    "rule": "optional"
                                  },
                                  "addonsSettings": {
                                    "type": ".squareup.devicesettings.profiles.v2.model.settings.squidkiosk.AddonsSettings",
                                    "id": 6,
                                    "rule": "optional"
                                  },
                                  "appearance": {
                                    "type": ".squareup.devicesettings.profiles.v2.model.settings.rst.common.Appearance",
                                    "id": 7,
                                    "rule": "optional"
                                  },
                                  "textCustomer": {
                                    "type": ".squareup.devicesettings.profiles.v2.model.settings.rst.common.TextCustomer",
                                    "id": 8,
                                    "rule": "optional"
                                  },
                                  "squidKiosk": {
                                    "type": ".squareup.devicesettings.profiles.v2.model.settings.squidkiosk.SquidKiosk",
                                    "id": 9,
                                    "rule": "optional"
                                  }
                                }
                              },
                              "AddonsSettings": {
                                "fields": {
                                  "loyalty": {
                                    "type": ".squareup.devicesettings.profiles.v2.model.settings.addons.Loyalty",
                                    "id": 1,
                                    "rule": "optional"
                                  },
                                  "textMessageMarketing": {
                                    "type": ".squareup.devicesettings.profiles.v2.model.settings.addons.TextMessageMarketing",
                                    "id": 2,
                                    "rule": "optional"
                                  }
                                }
                              },
                              "SquidKiosk": {
                                "fields": {
                                  "allowGiftCards": {
                                    "type": "bool",
                                    "id": 1,
                                    "rule": "optional",
                                    "options": {
                                      "default": false
                                    }
                                  },
                                  "diningOptions": {
                                    "type": ".squareup.devicesettings.profiles.v2.model.settings.squidkiosk.SquidKiosk.SquidKioskDiningOption",
                                    "id": 2,
                                    "rule": "repeated"
                                  },
                                  "showSoldOutItems": {
                                    "type": "bool",
                                    "id": 3,
                                    "rule": "optional",
                                    "options": {
                                      "default": true
                                    }
                                  }
                                },
                                "nested": {
                                  "SquidKioskDiningOption": {
                                    "fields": {
                                      "diningOptionId": {
                                        "type": "string",
                                        "id": 1,
                                        "rule": "optional"
                                      },
                                      "kioskOrdinal": {
                                        "type": "int32",
                                        "id": 2,
                                        "rule": "optional"
                                      }
                                    }
                                  }
                                }
                              }
                            }
                          }
                        }
                      }
                    }
                  }
                }
              }
            }
          }
        }
      }
    }
  }
};

// Do not initialize these protos if they have already been defined
if (!$root.nested?.squareup?.nested?.devicesettings?.nested?.profiles?.nested?.v2?.nested?.model?.nested?.settings?.nested?.squidkiosk?.nested?.SquidKioskSettings && !$root.nested?.squareup?.nested?.devicesettings?.nested?.profiles?.nested?.v2?.nested?.model?.nested?.settings?.nested?.squidkiosk?.nested?.AddonsSettings && !$root.nested?.squareup?.nested?.devicesettings?.nested?.profiles?.nested?.v2?.nested?.model?.nested?.settings?.nested?.squidkiosk?.nested?.SquidKiosk && !$root.nested?.squareup?.nested?.devicesettings?.nested?.profiles?.nested?.v2?.nested?.model?.nested?.settings?.nested?.squidkiosk?.nested?.SquidKiosk?.nested?.SquidKioskDiningOption) {
  $root.addJSON(jsonData);
}

/**
 * IMPORTANT: When Adding New Fields to Device Profiles, you MUST implement their default values at:
 *
 * /java/device-settings/src/main/java/com/squareup/devicesettings/processing/profiles/v2/defaults
 *
 * ⚠️ WARNING: Fields will not be automatically hydrated unless default values are implemented in the Java code above.
 * This is a mandatory step for all device profile settings.
 *
 * SOURCE SquidKioskSettings @ squareup/devicesettings/profiles/v2/model/settings/squidkiosk/squid_kiosk_settings.proto at 28:1
 */
export const SquidKioskSettings = $root.lookupType('squareup.devicesettings.profiles.v2.model.settings.squidkiosk.SquidKioskSettings');
fixType(SquidKioskSettings);
Builder.createAndAttachToType(SquidKioskSettings);
/**
 * SOURCE AddonsSettings @ squareup/devicesettings/profiles/v2/model/settings/squidkiosk/squid_kiosk_settings.proto at 44:1
 */
export const AddonsSettings = $root.lookupType('squareup.devicesettings.profiles.v2.model.settings.squidkiosk.AddonsSettings');
fixType(AddonsSettings);
Builder.createAndAttachToType(AddonsSettings);
/**
 * SOURCE SquidKiosk @ squareup/devicesettings/profiles/v2/model/settings/squidkiosk/squid_kiosk_settings.proto at 49:1
 */
export const SquidKiosk = $root.lookupType('squareup.devicesettings.profiles.v2.model.settings.squidkiosk.SquidKiosk');
fixType(SquidKiosk);
Builder.createAndAttachToType(SquidKiosk);
/**
 * SOURCE SquidKioskDiningOption @ squareup/devicesettings/profiles/v2/model/settings/squidkiosk/squid_kiosk_settings.proto at 54:3
 */
SquidKiosk.SquidKioskDiningOption = $root.lookupType('squareup.devicesettings.profiles.v2.model.settings.squidkiosk.SquidKiosk.SquidKioskDiningOption');
fixType(SquidKiosk.SquidKioskDiningOption);
Builder.createAndAttachToType(SquidKiosk.SquidKioskDiningOption);